import axios from "axios";

const data = JSON.parse(sessionStorage.getItem("body"));

const dataHeader = data
  ? `Basic ${btoa(data?.username + ":" + data?.password)}`
  : "";

export const api = axios.create({
  baseURL: "/api/v1/",
  headers: {
    "Content-Type": "application/json",
    Authorization: dataHeader,
  },
});

export const resetPassword = async (values) => {
  const url = `passwords/resetPassword`;
  const request = {
    ctaContrato: values.cuentaContrato,
    password: values.contraseña,
    hash: values.hash,
  };

  return await api.post(url, request);
};
export const createVale = async (values) => {
  const url = `vales/create`;
  const request = {
    empresa: values.empresa,
    tipoVale: values.tipoVale,
  };
  return await api.post(url, request);
};
export const recoverPassword = async (cuentaContrato) => {
  const url = `passwords/recoverPassword?ctaContrato=${cuentaContrato}`;
  return await api.get(url);
};

export const getValeById = async (valeId) => {
  const url = `vales/findById?valeId=${valeId}`;
  return await api.get(url);
};
export const getValeByEmpresaEstadoTipo = async (
  empresaId,
  estado,
  tipoValeId,
  size,
  page
) => {
  const url = `vales/findByEmpresaEstadoTipo?empresaId=${empresaId}&estado=${estado}&tipoValeId=${tipoValeId}&size=${size}&page=${page}`;
  return await api.get(url);
};
export const getVale = async (empresaId) => {
  const url = `vales/findByEmpresa?empresaId=${empresaId}`;
  return await api.get(url);
};
export const getEmpresasByCuentaContrato = async (cuentaContrato) => {
  const url = `empresas/findByCuentaContrato?cuentaContrato=${cuentaContrato}`;
  if (cuentaContrato) return await api.get(url);
};
export const getAllEmpresas = async () => {
  const url = `empresas/findAll`;
  return await api.get(url);
};
export const printXl = async (empresasId, fechaDesde, fechaHasta) => {
  const url = `movimientos/print?empresasId=${empresasId}&fechaDesde=${fechaDesde}&fechaHasta=${fechaHasta}`;
  return await api.get(url, { responseType: "arraybuffer" });
};
export const printXlAll = async (fechaDesde, fechaHasta) => {
  const url = `movimientos/printAllEmpresas?fechaDesde=${fechaDesde}&fechaHasta=${fechaHasta}`;
  return await api.get(url, { responseType: "arraybuffer" });
};

export const getSaldo = async (nroCuenta) => {
  const url = `cuentas/findByCuentaContrato?cuentaContrato=${nroCuenta}`;
  if (nroCuenta) return await api.get(url);
};

export const consumirVale = async (valeId, vaciaderoId) => {
  const url = `vales/consumirVale?valeId=${valeId}&vaciaderoId=${vaciaderoId}`;
  return await api.get(url);
};
